import * as React from 'react'
import {
  Stack,
  FieldLabel,
  FieldValue,
  Dropdown,
  ActionBar,
  Icon,
  Text,
} from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { ServiceItem } from '../../../../../../models/sale.constants'
import { ServiceItemBadge } from './ServiceItemBadge'
export interface Props {
  existingItems: ServiceItem[]
  handleSelectChange: (item: DropdownItem) => void
  setShouldShowDropdown: (val: boolean) => void
}

export interface DropdownItem {
  customBadge: React.JSX.Element
  id: string
  name: string
  description: string
}

export const ItemSelectForm: React.FC<Props> = ({
  existingItems,
  handleSelectChange,
  setShouldShowDropdown,
}) => {
  const t = useT()
  const itemSelectCopies = {
    customerItem: t('Customer’s item', {
      _context: 'Input label for service item step in service modal.',
    }),
    required: t('Required', {
      _context: 'Text for service item step in service modal.',
    }),
    addNewItem: t('Add new item', {
      _context: 'Text for service item step in service modal.',
    }),
    selectCustomerItem: t(`Select customer's item`, {
      _context:
        'Dropdown placeholder text for service item step in service modal.',
    }),
  }

  return (
    <form data-testid="item-select-form">
      <Stack space={5} className="vd-pt5">
        <Stack space={0}>
          <FieldLabel
            label={itemSelectCopies.customerItem}
            htmlFor="itemSelect"
            supplementaryLabel={itemSelectCopies.required}
          />
          <FieldValue>
            <Dropdown
              className="service-modal-dropdown"
              footer={
                <ActionBar>
                  <div
                    className="vd-colour-go"
                    onClick={() => setShouldShowDropdown(false)}
                    style={{
                      cursor: 'pointer',
                      height: '100%',
                      width: '100%',
                    }}
                  >
                    <Icon icon="plus" />
                    <Text className="vd-ml2">
                      {itemSelectCopies.addNewItem}
                    </Text>
                  </div>
                </ActionBar>
              }
              items={existingItems.map(item => ({
                customBadge: (
                  <ServiceItemBadge
                    header={item.itemName || ''}
                    description={item.serialNumber}
                  />
                ),
                id: item.itemId || '',
                name: item.itemName || '',
                description: item.serialNumber,
              }))}
              onEmptySelectCallback={() => {}}
              onFooterActiveCallback={() => {}}
              onOpenCallback={() => {}}
              onSelectCallback={item =>
                handleSelectChange(item as DropdownItem)
              }
              placeholder={itemSelectCopies.selectCustomerItem}
            />
          </FieldValue>
        </Stack>
      </Stack>
    </form>
  )
}
